// extracted by mini-css-extract-plugin
module.exports = {"orange-shadow":"OrangeDivider_orange-shadow__2qLMj","gradient":"OrangeDivider_gradient__2MS2g"};